import { loadTourTranslations, populateTourWithCopy } from './tourCopy';
async function importTourConfig(tourId) {
  try {
    return await import( /* webpackChunkName: "onboarding-tours-[request]" */
    `../tours/${tourId}`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production' && error.code === 'MODULE_NOT_FOUND') {
      console.warn(`%c🚧 Loaded WIP tour config for "%s"%c\n
This unfinished tour won't be included in production.\n
✅ To enable it, remove 'wip.' from the filename and add the required AT.`, 'color: orange; font-weight: bold;', tourId, '');
      return await import( /* webpackChunkName: "onboarding-tours-[request]" */
      `../tours/${tourId}.wip`);
    }
    throw error;
  }
}
export function getTourById(tourId) {
  return importTourConfig(tourId).then(getTourConfig => {
    // Call default export of tour config file, function can be async
    return (getTourConfig.default || getTourConfig)();
  }).then(async maybeTour => {
    await loadTourTranslations(tourId);
    const tourConfig = maybeTour.default || maybeTour;
    const tourWithCopy = populateTourWithCopy(tourId, tourConfig);
    return tourWithCopy;
  }).catch(error => {
    // Error is handled in OnboardingTour
    throw error;
  });
}
export function getTourFromConfig(tourId, tourConfig) {
  return new Promise(resolve => {
    if (typeof tourConfig === 'function') {
      resolve(tourConfig());
    } else {
      resolve(tourConfig);
    }
  }).then(async tour => {
    await loadTourTranslations(tourId);
    const tourWithCopy = populateTourWithCopy(tourId, tour);
    return tourWithCopy;
  }).catch(error => {
    // Error is handled in OnboardingTour
    throw error;
  });
}